import { MedicalConsentsAndAuthorizationsPrintCommand, Patient } from '@dreryk/egabinet-patient-frontend-api';
import { StoredFile } from '@dreryk/file-repository-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { printDocumentAsPdf } from '@dreryk/react-common';

import { MedicalConsentAndAuthorizationPrintBean } from './MedicalConsentAndAuthorizationsPrintModal';

type MedicalConsentAndAuthorizationsParameters = {
   patientId: Patient['id'];
} & MedicalConsentAndAuthorizationPrintBean;

export const usePrintMedicalConsentAndAuthorizations = (): UseCqrsCommandResult<
   StoredFile,
   MedicalConsentAndAuthorizationsParameters
> => {
   return useCqrsCommand<StoredFile, MedicalConsentAndAuthorizationsParameters>(
      (parameters) => {
         const command = new MedicalConsentsAndAuthorizationsPrintCommand();
         command.authorizationIds = parameters.confirmedAuthorizationsToPrint.map((id) => parseInt(id, 10));
         command.patientId = parameters.patientId;
         command.printConsent = parameters.patientConsentToPrint;
         return command;
      },
      {
         onSuccess: async (result) => {
            await printDocumentAsPdf({
               base64: result.data,
            });
         },
      }
   );
};
